import { ImageProps } from 'app/components/image';
import { i18n } from 'app/i18n';

import arrowLeft from './arrow-left.svg';
import arrowDisabled from './arrow-right-disabled.svg';
import arrowWhite from './arrow-right-white.svg';
import buildingIcon from './building.svg';
import cellTowerIcon from './cell-tower.svg';
import clock from './clock.svg';
import connectedFreeUnitImage from './connected-free-unit.svg';
import connectedUpgradeUnitImage from './connected-upgrade-unit.svg';
import emailIcon from './email.svg';
import errorIcon from './error.svg';
import gamingIcon from './gaming.svg';
import heartIcon from './heart.svg';
import house from './house.svg';
import largeHouseImage from './large-house.svg';
import mapPinIcon from './map-pin.svg';
import mediumHouseImage from './medium-house.svg';
import meshUnitSingle from './mesh-unit-single.svg';
import monkeyIcon from './monkey.svg';
import oneMeshUnitIcon from './one-mesh-unit.svg';
import owl from './owl.svg';
import personIcon from './person.svg';
import phoneIcon from './phone.svg';
import tvIcon from './tv.svg';
import twoMeshUnitsIcon from './two-mesh-units.svg';
import blackWifiIcon from './wifi-black.svg';
import wifiMeshUnit1 from './wifi-mesh-unit-1.png';
import wifiMeshUnit2 from './wifi-mesh-unit-2.png';
import wifiIcon from './wifi.svg';
import infoIcon from './info.svg';
import homeGateway from './home-gateway.svg';
import altiboxLogoIcon from './altibox-logo.png';

export const emailImageProps: ImageProps = {
    src: emailIcon,
    alt: i18n.image.email,
};

export const mapPinImageProps: ImageProps = {
    src: mapPinIcon,
    alt: i18n.image.mapPin,
};

export const wifiImageProps: ImageProps = {
    src: wifiIcon,
    alt: i18n.image.wifi,
};

export const heartImageProps: ImageProps = {
    src: heartIcon,
    alt: i18n.image.heart,
};

export const personImageProps: ImageProps = {
    src: personIcon,
    alt: i18n.image.person,
};

export const buildingImageProps: ImageProps = {
    src: buildingIcon,
    alt: i18n.image.building,
};

export const mediumHouseImageProps: ImageProps = {
    src: mediumHouseImage,
    alt: i18n.image.mediumHouse,
};

export const largeHouseImageProps: ImageProps = {
    src: largeHouseImage,
    alt: i18n.image.largeHouse,
};

export const blackWifiImageProps: ImageProps = {
    src: blackWifiIcon,
    alt: i18n.image.wifi,
};

export const tvImageProps: ImageProps = {
    src: tvIcon,
    alt: i18n.image.tv,
};

export const phoneImageProps: ImageProps = {
    src: phoneIcon,
    alt: i18n.image.phone,
};

export const gamingImageProps: ImageProps = {
    src: gamingIcon,
    alt: i18n.image.gaming,
};

export const errorImageProps: ImageProps = {
    src: errorIcon,
    alt: i18n.image.error,
};

export const connectedFreeUnitImageProps: ImageProps = {
    src: connectedFreeUnitImage,
    alt: i18n.image.connectedFreeUnit,
};

export const connectedUpgradeUnitImageProps: ImageProps = {
    src: connectedUpgradeUnitImage,
    alt: i18n.image.connectedUpgradeUnit,
};

export const oneMeshUnitImageProps: ImageProps = {
    src: oneMeshUnitIcon,
    alt: i18n.image.oneMeshUnit,
};

export const twoMeshUnitsImageProps: ImageProps = {
    src: twoMeshUnitsIcon,
    alt: i18n.image.twoMeshUnits,
};

export const arrowWhiteImageProps: ImageProps = {
    src: arrowWhite,
    alt: i18n.image.arrowRight,
};

export const arrowDisabledImageProps: ImageProps = {
    src: arrowDisabled,
    alt: i18n.image.arrowRight,
};

export const arrowLeftImageProps: ImageProps = {
    src: arrowLeft,
    alt: i18n.image.arrowLeft,
};

export const houseImageProps: ImageProps = {
    src: house,
    alt: i18n.image.housing,
};

export const owlImageProps: ImageProps = {
    src: owl,
    alt: i18n.image.owl,
};

export const monkeyImageProps: ImageProps = {
    src: monkeyIcon,
    alt: i18n.image.monkey,
};

export const meshUnitImageProps: ImageProps = {
    src: meshUnitSingle,
    alt: i18n.image.singleMeshUnit,
};

export const wifiMeshUnitAllImages: ImageProps[] = [wifiMeshUnit1, wifiMeshUnit2].map((image) => ({
    src: image,
    alt: i18n.image.wifiMeshUnit,
}));

export const wifiMeshUnitImageProps: ImageProps = {
    src: wifiMeshUnit1,
    alt: i18n.image.wifiMeshUnit,
};

export const clockImageProps: ImageProps = {
    src: clock,
    alt: i18n.image.clock,
};

export const homeGatewayImageProps: ImageProps = {
    src: homeGateway,
    alt: i18n.image.homeGateway,
};

export const infoImageProps: ImageProps = {
    src: infoIcon,
    alt: i18n.image.info,
};

export const altiboxLogoImageProps: ImageProps = {
    src: altiboxLogoIcon,
    alt: i18n.image.altiboxLogo,
};

export const cellTowerImageProps: ImageProps = {
    src: cellTowerIcon,
    alt: i18n.image.fixedWirelessAccess,
};
